import { useDispatch } from "react-redux";
import "./App.css";
import Header from "./components/header/header";
import Sidebar from "./components/sidebar/sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { currentUserRequest } from "./redux/users/slice";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    if (!accessToken) {
      sessionStorage.clear();
      navigate("/signin");
      return;
    }
    dispatch(currentUserRequest());
  }, [dispatch, navigate]);

  return (
    <>
      <Header />
      <Sidebar />
      <div id="detail" style={{ marginTop: 60, marginLeft: 240, padding: 20 }}>
        <Outlet />
      </div>
    </>
  );
}

export default App;
